import React from 'react';
import { motion } from 'framer-motion';
import { Target, LineChart, Users, Zap, CheckCircle2 } from 'lucide-react';
export function Solutions() {
  const solutions = [{
    icon: Target,
    title: 'Revenue-First Keyword Strategy',
    description: "We don't chase high-volume vanity keywords that don't convert. We target high-intent, bottom-of-funnel queries where your actual buyers are searching.",
    bullets: ['Intent mapping', 'Competitor gap analysis', 'Commercial query focus']
  }, {
    icon: LineChart,
    title: 'Transparent, Board-Ready Reporting',
    description: 'Get dashboards that speak the language of the C-suite. We tie organic traffic directly to pipeline generation, MQLs, and closed-won revenue.',
    bullets: ['Custom Looker Studio dashboards', 'CRM integration', 'ROI tracking']
  }, {
    icon: Users,
    title: 'Senior Talent Only',
    description: 'No bait-and-switch. The senior strategists who pitch your account are the ones actually doing the work and running your monthly calls.',
    bullets: ['10+ years average experience', 'Direct access to specialists', 'Proactive strategy']
  }, {
    icon: Zap,
    title: 'Technical Excellence',
    description: 'We fix the underlying architecture of your site so Google can crawl, render, and index your content flawlessly, giving you an unfair advantage.',
    bullets: ['Core Web Vitals optimization', 'Schema markup', 'Crawl budget management']
  }];
  return <section className="py-24 bg-slate-900 text-white relative overflow-hidden" id="services" data-id="element-180">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-181"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-182">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-183">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-800 text-brand-400 text-sm font-semibold mb-6 border border-slate-700" data-id="element-184">
            The Antidote to Bad SEO
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-extrabold mb-6 tracking-tight" data-id="element-185">
            How we turn search into your most predictable revenue channel.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-slate-400" data-id="element-186">
            We align our SEO strategy with your business objectives. If it
            doesn't move the needle on revenue, we don't do it.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-187">
          {solutions.map((solution, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-8 hover:bg-slate-800 transition-colors" data-id="element-188">
              <div className="w-12 h-12 rounded-xl bg-brand-500/20 flex items-center justify-center mb-6 border border-brand-500/30" data-id="element-189">
                <solution.icon className="w-6 h-6 text-brand-400" data-id="element-190" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-191">{solution.title}</h3>
              <p className="text-slate-400 mb-6 leading-relaxed" data-id="element-192">
                {solution.description}
              </p>
              <ul className="space-y-2" data-id="element-193">
                {solution.bullets.map((bullet, i) => <li key={i} className="flex items-center gap-2 text-sm text-slate-300" data-id="element-194">
                    <CheckCircle2 className="w-4 h-4 text-brand-400 flex-shrink-0" data-id="element-195" />
                    {bullet}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}